import { getToken } from 'next-auth/jwt';
import { getSession } from 'next-auth/react';
import Head from 'next/head';
import { GetServerSideProps } from 'next/types';

import { SESSION_COOKIE_SETTINGS } from 'modules/common/constants';
import { Login } from 'modules/components/Login';
import { ROUTES } from 'modules/routes';

const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;

const gtmScript = (id: string) =>
  `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${id}');`;

export default function LoginPage() {
  return (
    <>
      {GTM_ID && (
        <>
          <Head>
            <script dangerouslySetInnerHTML={{ __html: gtmScript(GTM_ID) }} />
          </Head>
          <noscript>
            <iframe
              title="Google Tag Manager"
              src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
              height="0"
              width="0"
              style={{ display: 'none', visibility: 'hidden' }}
            />
          </noscript>
        </>
      )}
      <Login />
    </>
  );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { req } = context;

  const jwt = await getToken({
    req,
    cookieName: SESSION_COOKIE_SETTINGS.sessionToken.name,
  });

  const session = await getSession({ req });

  if (jwt && session) {
    return {
      redirect: {
        permanent: false,
        destination: ROUTES.SHOPS_LIST,
      },
    };
  }

  return { props: {} };
};
